<template>
  <div class="home">
    <div class="userInfo">
      <div class="header">
        <div class="pHeader">
          <h3>信息维护</h3>
          <h2 @click="$router.go(-1)">返回</h2>
        </div>
        <div class="line"></div>
      </div>
      <div class="pNav">
        <div class="pNavLeft">
          <ul>
            <li
              :class="index == tabIndex ? 'selected' : ''"
              :style="index == 0 ? 'border-left:none' : ''"
              v-for="(item, index) in tabNav"
              :key="item"
              @click="changeTab(item, index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="pNavRight">
          <h3 @click="showDio">添加</h3>
        </div>
      </div>
      <div class="nextNav">
        <div class="nextNavLeft">
          <ul>
            <li
              :class="index == dentityIndex ? 'selected' : ''"
              :style="index == 0 ? 'border-left:none' : ''"
              v-for="(item, index) in dentityNav"
              :key="item"
              @click="changeDentity(item, index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="nextNavRight">
          <el-input
            placeholder="搜索"
            suffix-icon="el-icon-search"
            @keyup.enter.native="search"
            v-model="keyword"
            size="mini"
            style="width: 0.8rem"
          ></el-input>
          <el-select
            v-model="statusvalue"
            @clear="clearStatus"
            @change="changeStatus"
            size="mini"
            clearable
            placeholder="请选择排序方式"
          >
            <el-option
              v-for="item in optionsStatus"
              :key="item.sort"
              :label="item.value"
              :value="item.sort"
            ></el-option>
          </el-select>
          <el-select
            v-model="value"
            @change="selectChange"
            size="mini"
            clearable
            placeholder="请选择排序方式"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.value"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="user">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <!-- <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            min-width="4%"
            align="center"
          ></el-table-column> -->
          <el-table-column label="序号" align="center" min-width="4%">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (paginations.page_index - 1) * 10 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            :label="tabIndex == 0 ? '捐赠人姓名' : '受助人姓名'"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column
            prop="donortime"
            show-overflow-tooltip
            label="时间"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column
            prop="money"
            :label="tabIndex == 0 ? '捐赠金额' : '受助金额'"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column
            prop="checks"
            label="状态"
            align="center"
            min-width="5%"
          >
            <template slot-scope="scope">
              <span style="color: red" v-if="scope.row.checks == 1"
                >核对失败:{{ scope.row.reject }}</span
              >
              <span style="color: #999999" v-else-if="scope.row.checks == 0"
                >核对中</span
              >
              <span style="color: #00ff00" v-else-if="scope.row.checks == 2"
                >已核对</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="电话号码"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column
            prop="contact"
            label="联系地址"
            align="center"
            min-width="5%"
          ></el-table-column>
          <el-table-column
            v-if="tabIndex == 1"
            label="资料文件"
            align="center"
            min-width="6%"
          >
            <template slot-scope="scope">
              <el-button size="mini" @click="download(scope.row, scope.$index)"
                >个人文件</el-button
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="5%">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row, scope.$index)"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div class="tspage"> -->
      <div class="tspage" v-if="paginations.total > paginations.page_size">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="paginations.page_index"
          :page-size="paginations.page_size"
          :total="paginations.total"
          layout="prev, pager, next"
        ></el-pagination>
      </div>
      <el-dialog
        :title="(edShow ? '编辑' : '添加') + tabNav[tabIndex]"
        :visible.sync="grShow"
        width="35%"
        :before-close="handleClose"
      >
        <el-tabs v-model="gractriveName" @tab-click="grhandleClick">
          <el-tab-pane label="个人" name="first"></el-tab-pane>
          <el-tab-pane label="团队" name="second"></el-tab-pane>
        </el-tabs>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="1rem"
          class="demo-ruleForm"
        >
          <el-form-item
            v-if="gractriveName == 'first'"
            label="姓名"
            prop="name"
          >
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item v-else label="单位名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="时间" prop="donortime">
            <!-- <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.date1"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker placeholder="选择时间" v-model="ruleForm.date2" style="width: 100%;"></el-time-picker>
              </el-form-item>
            </el-col>-->
            <el-date-picker
              v-model="ruleForm.donortime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="金额" prop="money">
            <el-input v-model.number="ruleForm.money"></el-input>
          </el-form-item>
          <el-form-item label="电话号码" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="contact">
            <el-input v-model="ruleForm.contact"></el-input>
          </el-form-item>
          <el-form-item v-if="tabIndex == 1" label="证明文档">
            <el-upload
              class="upload-demo"
              action="http://123.56.170.62:9999/tianwei/recipient"
              ref="pictUpload"
              :file-list="pictfileList"
              :on-change="picthandleChange"
              :limit="1"
              :before-upload="pictbeforeAvatarUpload"
              :auto-upload="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传pdf文件，且不超过10M
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm()">放弃</el-button>
            <el-button
              v-if="!edShow"
              type="primary"
              style="margin: 0 0.2rem 0 0.3rem"
              @click="goAdd('ruleForm')"
              >继续添加</el-button
            >
            <el-button
              v-if="!edShow"
              type="primary"
              @click="submitForm('ruleForm')"
              >保存</el-button
            >
            <el-button v-if="edShow" type="primary" @click="edit('ruleForm')"
              >确定编辑</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js"
import moment from "moment"
import { BASE_URL } from "@/utils/base.js"
import {
  addJzUser,
  getJzUserList,
  getSzUserList,
  addSzUser,
} from "@/api/user.js"
export default {
  name: "Home",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"))
      }
      setTimeout(() => {
        if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
          callback(new Error("请输入正确手机号"))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      grShow: false,
      edShow: false,
      // ttShow: false,
      gractriveName: "first",
      tabNav: ["捐赠信息", "受赠信息"],
      tabIndex: 0,
      dentityNav: ["个人", "团队"],
      dentityIndex: 0,
      tableData: [],
      value: { value: "按时间由低到高排序", content: "时间", sort: false },
      keyword: "",
      statusvalue: null,
      options: [
        { value: "按时间由低到高排序", content: "时间", sort: false },
        { value: "按时间由高到低排序", content: "时间", sort: true },
        { value: "按金额由高到低排序", content: "金额", sort: false },
        { value: "按金额由低到高排序", content: "金额", sort: true },
      ],
      optionsStatus: [
        { value: "核对中", sort: 0 },
        { value: "核对失败", sort: 1 },
        { value: "已核对", sort: 2 },
      ],
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      ruleForm: {
        name: "",
        donortime: "",
        money: "",
        phone: "",
        contact: "",
      },
      pictfileList: [],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        contact: [{ required: true, message: "请输入地址", trigger: "blur" }],
        money: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { type: "number", message: "金额必须为数字值" },
        ],
        donortime: [
          {
            required: true,
            message: "请选择日期",
            trigger: "blur",
          },
        ],
      },
      newFile: null,
    }
  },
  mounted() {
    if (this.$route.params.pid) {
      this.getList()
    } else {
      this.$router.go(-1)
    }
    this.$nextTick(function() {
      Bus.$emit("getCmsCurrent", "/myProgram")
    })
  },
  methods: {
    //导航切换
    changeTab(item, index) {
      this.tabIndex = index
      this.getList()
    },
    // 身份切换
    changeDentity(item, index) {
      this.dentityIndex = index
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.getList()
    },
    pictbeforeAvatarUpload(file) {
      this.newFile = file
      return false
    },
    picthandleChange(file, fileList) {
      const isJPG = file.raw.type === "application/pdf"
      const isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error("证明文档只能是 PDF 格式!")
      }
      if (!isLt2M) {
        this.$message.error("文档大小不能超过 10MB!")
      }
      if (!isJPG || !isLt2M) {
        this.pictfileList = []
      } else {
        this.pictfileList = fileList.slice(-3)
        // this.ruleForm.picture = URL.createObjectURL(file.raw);
      }
    },
    // 文件下载
    download(item, index) {
      window.open(BASE_URL + item.file, "_blank")
    },
    // 获取列表
    async getList() {
      let userList = new FormData()
      userList.append("dentity", this.dentityNav[this.dentityIndex])
      userList.append("page", this.paginations.page_index)
      userList.append("rows", this.paginations.page_size)
      userList.append("keyword", this.$route.params.pid)
      userList.append("sids", this.value.sort)
      userList.append("school", this.value.content)
      if (this.keyword) {
        userList.append("name", this.keyword)
      }
      if (this.statusvalue == 0 || this.statusvalue) {
        userList.append("xueyuan", this.statusvalue)
      }
      if (this.tabIndex == 0) {
        let listInfo = await getJzUserList(userList)
        this.paginations.total = listInfo.total
        this.tableData = listInfo.rows
      } else {
        let listInfo = await getSzUserList(userList)
        this.paginations.total = listInfo.total
        this.tableData = listInfo.rows
      }
    },
    // 排序下拉框选中
    selectChange(item) {
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.statusvalue = null
      this.getList()
    },
    // 下拉框清空
    clearStatus() {
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.statusvalue = null
      this.getList()
    },
    // 下拉框状态值切换
    changeStatus(item) {
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
      this.statusvalue = item
      this.getList()
    },
    // 搜索
    search() {
      if (this.keyword) {
        this.paginations = {
          page_index: 1, // 当前位于哪页
          total: 0, // 总数
          page_size: 5, // 1页显示多少条
          layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
        }
        this.getList()
      } else {
        this.$message.warning("搜索内容不能为空")
      }
    },
    // 添加弹窗
    showDio() {
      this.grShow = true
    },
    // 添加时身份选择
    grhandleClick(tab, event) {
      this.gractriveName = tab.name
    },
    // 弹窗关闭
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm()
          done()
        })
        .catch((_) => {})
    },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let addUser = new FormData()
          addUser.append("name", this.ruleForm.name)
          addUser.append(
            "donortime",
            moment(this.ruleForm.donortime).format("YYYY-MM-DD h:mm")
          )
          addUser.append("money", this.ruleForm.money)
          addUser.append("contact", this.ruleForm.contact)
          addUser.append("phone", this.ruleForm.phone)
          if (this.gractriveName == "first") {
            addUser.append("status", "个人")
          } else if (this.gractriveName == "second") {
            addUser.append("status", "团队")
          }
          addUser.append("did", this.$route.params.pid)
          if (this.tabIndex == 0) {
            let user = await addJzUser(addUser)
            if (user.code == "OK") {
              this.$message.success(user.msg)
              this.getList()
              this.resetForm()
            } else {
              this.$message.error(user.msg)
            }
          } else {
            this.$refs.pictUpload.submit()
            if (this.pictfileList.length == 0) {
              this.$message({
                type: "warning",
                message: "项目封面上传未完成",
              })
              return false
            }
            addUser.append("files", this.newFile)
            let user = await addSzUser(addUser)
            if (user.code == "OK") {
              this.$message.success(user.msg)
              this.getList()
              this.resetForm()
            } else {
              this.$message.error(user.msg)
            }
          }
        } else {
          return false
        }
      })
    },
    // 编辑
    edit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let addUser = new FormData()
          addUser.append("name", this.ruleForm.name)
          addUser.append(
            "donortime",
            moment(this.ruleForm.donortime).format("YYYY-MM-DD h:mm:ss")
          )
          addUser.append("money", this.ruleForm.money)
          addUser.append("contact", this.ruleForm.contact)
          addUser.append("phone", this.ruleForm.phone)
          if (this.gractriveName == "first") {
            addUser.append("status", "个人")
          } else if (this.gractriveName == "second") {
            addUser.append("status", "团队")
          }
          addUser.append("id", this.ruleForm.id)
          if (this.tabIndex == 0) {
            let user = await addJzUser(addUser)
            if (user.code == "OK") {
              this.$message.success(user.msg)
              this.getList()
              this.resetForm()
            } else {
              this.$message.error(user.msg)
            }
          } else {
            this.$refs.pictUpload.submit()
            if (this.pictfileList.length == 0) {
            } else {
              addUser.append("files", this.newFile)
            }
            let user = await addSzUser(addUser)
            if (user.code == "OK") {
              this.$message.success(user.msg)
              this.getList()
              this.resetForm()
            } else {
              this.$message.error(user.msg)
            }
          }
        } else {
          return false
        }
      })
    },
    // 继续添加
    goAdd(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let addUser = new FormData()
          addUser.append("name", this.ruleForm.name)
          addUser.append(
            "donortime",
            moment(this.ruleForm.donortime).format("YYYY-MM-DD h:mm:ss")
          )
          addUser.append("money", this.ruleForm.money)
          addUser.append("contact", this.ruleForm.contact)
          addUser.append("phone", this.ruleForm.phone)
          if (this.gractriveName == "first") {
            addUser.append("status", "个人")
          } else if (this.gractriveName == "second") {
            addUser.append("status", "团队")
          }
          addUser.append("did", this.$route.params.pid)
          if (this.tabIndex == 0) {
            let user = await addJzUser(addUser)
            if (user.code == "OK") {
              this.$message.success(user.msg)
              ;(this.ruleForm = {
                name: "",
                donortime: "",
                money: "",
                phone: "",
                contact: "",
              }),
                (this.gractriveName = "first")
            } else {
              this.$message.error(user.msg)
            }
          } else {
            this.$refs.pictUpload.submit()
            if (this.pictfileList.length == 0) {
              this.$message({
                type: "warning",
                message: "项目封面上传未完成",
              })
              return false
            }
            addUser.append("files", this.newFile)
            let user = await addSzUser(addUser)
            if (user.code == "OK") {
              this.$message.success(user.msg)
              ;(this.ruleForm = {
                name: "",
                donortime: "",
                money: "",
                phone: "",
                contact: "",
              }),
                (this.gractriveName = "first")
              this.newFile = null
              this.pictfileList = []
            } else {
              this.$message.error(user.msg)
            }
          }
        } else {
          return false
        }
      })
    },
    // 放弃
    resetForm() {
      ;(this.ruleForm = {
        name: "",
        donortime: "",
        money: "",
        phone: "",
        contact: "",
      }),
        (this.gractriveName = "first")
      this.newFile = null
      this.pictfileList = []
      this.grShow = false
      this.edShow = false
    },
    // 编辑
    handleEdit(item, index) {
      if (item.status == "个人") {
        this.gractriveName = "first"
      } else if (item.status == "团队") {
        this.gractriveName = "second"
      }
      this.ruleForm = item
      this.grShow = true
      // this.ruleForm.name = item.name
      // this.ruleForm.donortime = item.donortime
      // this.ruleForm.money = item.money
      // this.ruleForm.phone = item.phone
      // this.ruleForm.contact = item.contact
      // this.ruleForm.id = item.id
      this.edShow = true
    },
    indexMethod(index) {
      return index + (this.paginations.page_index - 1) * 10 + 1
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val
      this.getList()
    },
  },
  components: {},
}
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  padding: 10px 0 40px;
  min-height: calc(100vh - 200px);
  margin-bottom: 60px;
  .userInfo {
    margin: 0 50px;
    .header {
      width: 100%;
      .pHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          margin: 20px 0;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }
        h2 {
          width: 100px;
          height: 26px;
          line-height: 26px;
          color: #fff;
          font-size: 12px;
          border-radius: 5px;
          text-align: center;
          background-color: #0687c8;
          cursor: pointer;
        }
      }

      .line {
        width: 100%;
        background-color: #dbdbdb;
        height: 1px;
      }
    }
    .pNav {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: 100%;
      border-bottom: 1px solid #dbdbdb;
      .pNavLeft {
        ul {
          display: flex;
          li {
            width: 70px;
            font-size: 14px;
            margin-right: 14px;
            color: #4d4d4d;
            text-align: center;
            cursor: pointer;
            padding-bottom: 10px;
          }
          .selected {
            border-bottom: 1px solid #0687c8;
            color: #0687c8;
          }
        }
      }
      .pNavRight {
        h3 {
          width: 80px;
          height: 26px;
          line-height: 26px;
          color: #4d4d4d;
          font-size: 12px;
          border-radius: 5px;
          border: 1px solid #dbdbdb;
          text-align: center;
          margin-bottom: 10px;
          background-color: #fff;
          cursor: pointer;
        }
      }
    }
    .nextNav {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .nextNavLeft {
        ul {
          display: flex;
          li {
            width: 70px;
            font-size: 14px;
            height: 14px;
            line-height: 14px;
            border-left: 1px solid #ebebeb;
            color: #4d4d4d;
            text-align: center;
            cursor: pointer;
          }
          .selected {
            color: #0687c8;
          }
        }
      }
      .nextNavRight {
        /deep/ .el-input {
          width: 160px;
          margin-left: 20px;
        }
      }
    }
    .tspage {
      margin: 30px 0 30px;
      text-align: center;
      /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #0687c8;
        border: none;
      }
      /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        // color: #fff;
      }
      /deep/ .el-pagination.is-background button {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        // color: #fff;
      }
    }
  }
}
</style>
